/**
 * Error Display - Handles error overlay UI
 */

export class ErrorDisplay {
  constructor() {
    this.overlay = null;
    this.content = null;
    this.indicator = null;
    this.hasError = false;
    this.minimizeBtn = null;

    // Bound handlers for cleanup
    this.boundHandlers = {};
  }

  /**
   * Initialize with DOM elements
   */
  init() {
    this.overlay = document.getElementById('error-overlay');
    this.content = document.getElementById('error-content');
    this.indicator = document.getElementById('error-indicator');

    this.setupEventListeners();
  }

  setupEventListeners() {
    // Minimize button
    this.minimizeBtn = document.getElementById('btn-minimize-error');
    this.boundHandlers.minimize = () => this.minimize();
    this.minimizeBtn.addEventListener('click', this.boundHandlers.minimize);

    // Indicator click to expand
    this.boundHandlers.expand = () => this.expand();
    this.indicator.addEventListener('click', this.boundHandlers.expand);
  }

  /**
   * Show error message
   * @param {string} message
   */
  show(message) {
    this.hasError = true;
    this.content.textContent = message;
    this.overlay.classList.remove('hidden');
    this.indicator.classList.add('hidden');
  }

  /**
   * Clear error display
   */
  clear() {
    this.hasError = false;
    this.overlay.classList.add('hidden');
    this.indicator.classList.add('hidden');
  }

  /**
   * Minimize error overlay to indicator
   */
  minimize() {
    this.overlay.classList.add('hidden');
    this.indicator.classList.remove('hidden');
  }

  /**
   * Expand error indicator to overlay
   */
  expand() {
    this.overlay.classList.remove('hidden');
    this.indicator.classList.add('hidden');
  }

  /**
   * Clean up event listeners
   */
  destroy() {
    if (this.minimizeBtn && this.boundHandlers.minimize) {
      this.minimizeBtn.removeEventListener('click', this.boundHandlers.minimize);
    }
    if (this.indicator && this.boundHandlers.expand) {
      this.indicator.removeEventListener('click', this.boundHandlers.expand);
    }
    this.boundHandlers = {};
  }
}
